<div class="modals__container">
  <div class="modals__header">
    <img
      mfpLazyImage
      lazySrc="assets/icons/close.svg"
      alt=""
      class="modals__close"
      (click)="close()"
    />
  </div>
  <div class="saving-goals">
    <h1 class="saving-goals__title">{{ 'SAVING_GOALS.TITLE' | translate }}</h1>
    <form
      class="saving-goals__form"
      [formGroup]="sgForm"
      mfpInvalidFormScroll
      [invalidFormScrollOffset]="70"
      invalidFormScrollContainerId="modalScrollContainer"
      (ngSubmit)="save()"
    >
      <div class="saving-goals__box mfp-white-box">
        <h2 class="saving-goals__box-title">{{ 'SAVING_GOALS.BOX.TITLE' | translate }}</h2>
        <div id="modalScrollContainer" class="saving-goals__box-content">
          <mfp-dynamic-list
            name="futurePlans"
            [formArray]="futurePlansFormArray"
            [createControl]="createFuturePlansDefaultValue"
            [addButtonLabel]="'FINANCIAL.FORM.FUTURE_PLANS.ITEM.ADD' | translate"
          >
            <ng-template
              let-formControl="formControl"
              let-index="index"
              let-removeItem="removeItem"
            >
              <mfp-future-plan
                view="agent"
                goalTypeName="type"
                goalAmountName="goalAmount"
                assuredAmountName="assuredAmount"
                dateName="goalDate"
                [form]="formControl"
                [label]="'FINANCIAL.FORM.FUTURE_PLANS.ITEM.TITLE' | translate: { i: index + 1 }"
                [goalTypeLabel]="'FINANCIAL.FORM.FUTURE_PLANS.ITEM.TYPE' | translate"
                [goalTypePlaceholder]="'FORMS.SELECT_PLACEHOLDER' | translate"
                [goalAmountLabel]="'FINANCIAL.FORM.FUTURE_PLANS.ITEM.GOAL_AMOUNT' | translate"
                [assuredAmountLabel]="'FINANCIAL.FORM.FUTURE_PLANS.ITEM.ASSURED_AMOUNT' | translate"
                [dateLabel]="'FINANCIAL.FORM.FUTURE_PLANS.ITEM.YEAR' | translate"
                [datePlaceholder]="'FINANCIAL.FORM.FUTURE_PLANS.ITEM.YEAR_PLACEHOLDER' | translate"
                [dateErrorData]="goalYearsLimit"
                [removeLabel]="'FINANCIAL.FORM.FUTURE_PLANS.ITEM.DELETE' | translate"
                [currencyOptions]="currencyOptions"
                [goalTypeOptions]="futurePlansOptions"
                (removeItem)=" futurePlansFormArray.length > 1 ? removeItem() : closeAndSave()"
              ></mfp-future-plan>
            </ng-template>
          </mfp-dynamic-list>
        </div>
      </div>

      <div class="saving-goals__actions">
        <mfp-button
          type="button"
          color="primary"
          fill="outline"
          [label]="'CANCEL' | translate"
          [disabled]="false"
          (click)="close()"
        ></mfp-button>

        <mfp-button
        class="saving-goals__actions-save"
          type="submit"
          color="primary"
          fill="default"
          [label]="'SAVE' | translate"
          [disabled]="false"
        ></mfp-button>
      </div>
    </form>
  </div>
</div>
